/*eslint no-sequences: "off"*/
/*eslint no-empty-pattern: "off"*/

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IModalContext, IModalContentTypes } from './interfaces';
import { initState } from './init.state';


export interface OpenModalPayload {
  content: IModalContentTypes;
  props?: any;
  type?: string;
  visible?: boolean;
  show?: boolean;
}

export const ModalContextSlice = createSlice({
  name: 'modalContext',
  initialState: initState,
  reducers: {
    OpenModal: (state: IModalContext, action: PayloadAction<OpenModalPayload>) => {
      return {
        ...state,
        open: true,
        content: action.payload.content,
        props: action.payload.props
      };
    },

    CloseModal: (state: IModalContext) => {
      return {
        ...state,
        open: false,
        content: 'BASIC' as IModalContentTypes
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { OpenModal, CloseModal } = ModalContextSlice.actions;

export default ModalContextSlice.reducer;
